module.exports = __webpack_public_path__ + "img/EyeView.9073f34e.png";